import React from 'react';
import { Button, Grid, Header } from 'semantic-ui-react';

import { ClearableCheckboxDropdown, ListThumbnailViewer, EmptyListPlaceholder, SearchBar, USER_PERMISSIONS, PRODUCT_PERMISSIONS } from "dyl-components";
import EmailTemplateTable from './subcomponents/EmailTemplateTable';

import './index.scss';
import EmailTemplateThumbnail from './subcomponents/EmailTemplateThumbnail';
import RestrictedView from 'dyl-components/molecules/Restricted';

const EmailTemplates = ({
    templates,

    search,
    onChangeSearch,
    onSearchSubmit,
    onSearchCancel,
    filters,
    filterOptions = [
        { key: 'My Templates', value: 'My Templates', text: 'My Templates' },
        { key: 'Shared Templates', value: 'Shared Templates', text: 'Shared Templates' },
    ],
    onChangeSelectedFilters,
    categories,
    categoryOptions = [
        { key: 1, value: 1, text: 'Sales' },
        { key: 2, value: 2, text: 'Marketing' },
        { key: 3, value: 3, text: 'Service' },
        { key: 4, value: 4, text: 'General' },
        { key: 5, value: 5, text: 'Billing' }
    ],
    onChangeSelectedCategories,


    onPreview = () => { },
    onEdit = () => { },
    onCopy = () => { },
    onDelete = () => { },
    onOpenAddTemplateModal,

    page,
    count,
    isReading,
    isReadingUserProductLimts,
}) => (
    <ListThumbnailViewer
        view='thumbnail'
        header={
            <React.Fragment>
                <Grid.Column width={5} style={{ padding: 0 }}>
                    <SearchBar
                        addClassNames='EmailTemplate__SearchBar'
                        search={search}
                        isSearching={isReading}
                        searchFcn={onSearchSubmit}
                        cancelFcn={onSearchCancel}
                        onChange={onChangeSearch}
                        placeholder='Search by Email Template Name'
                    />
                </Grid.Column>
                <Grid.Column width={3} style={{ padding: 0, marginLeft: 15 }}>
                    <ClearableCheckboxDropdown
                        options={filterOptions}
                        name='filters'
                        onChange={onChangeSelectedFilters}
                        value={filters}
                        selection
                        text={<span>Filters{filters && filters.length ? <b className='EmailTemplate_FilterDisplay'> {filters.length} Selected</b> : ''}</span>}
                        fluid={true}
                    />
                </Grid.Column>
                <Grid.Column width={3} style={{ padding: 0, marginLeft: 10 }}>
                    <ClearableCheckboxDropdown
                        options={categoryOptions}
                        name='categories'
                        onChange={onChangeSelectedCategories}
                        value={categories}
                        selection
                        text={<span>Category{categories && categories.length ? <b className='EmailTemplate_FilterDisplay'> {categories.length} Selected</b> : ''}</span>}
                        fluid={true}
                    />
                </Grid.Column>
                <Grid.Column width={3} floated='right' style={{ padding: 0 }}>
                    <RestrictedView type='disabled' productPermission={PRODUCT_PERMISSIONS.SETTINGS_EMAIL_TEMPLATES} userPermission={USER_PERMISSIONS.LIBRARY_ADD}>
                        <Button disabled={isReadingUserProductLimts} onClick={onOpenAddTemplateModal} floated='right' className='EmailTemplate__NewTemplateButton'>+ New Email Template</Button>
                    </RestrictedView>
                </Grid.Column>
            </React.Fragment>
        }
        listView={
            <EmailTemplateTable
                count={count}
                isReading={isReading}
                templates={templates}
                isSearchEmpty={!search}
                onOpenAddTemplateModal={onOpenAddTemplateModal}
                onPreview={onPreview}
                onEdit={onEdit}
                onCopy={onCopy}
                onDelete={onDelete}
            />
        }
        thumbnailView={
            <React.Fragment>
                {!isReading && count === 0 ? (search !== '' ? <Header as='h3'>No Results Found</Header> :
                    <Grid.Column width={16} textAlign='center'>
                        <EmptyListPlaceholder name='Email Template' onClick={onOpenAddTemplateModal} productPermission={PRODUCT_PERMISSIONS.SETTINGS_EMAIL_TEMPLATES} userPermission={USER_PERMISSIONS.LIBRARY_ADD}/>
                    </Grid.Column>)
                    :
                    <EmailTemplateThumbnail
                        key={page}
                        isReading={isReading}
                        templates={templates}
                        onPreview={onPreview}
                        onEdit={onEdit}
                        onCopy={onCopy}
                        onDelete={onDelete}
                    />
                }
            </React.Fragment>
        }
    />


);

export default EmailTemplates;

